import type { Theme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { ERebrandingColors } from 'helpers/constants';

const valueAvailableDefaultRules = (theme: Theme) => ({
  margin: '14px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: 16,
  lineHeight: '150%',
  color: theme.palette.grey[500],
});

const inputValueDefaultRules = (theme: Theme, applyWarningStyle?: boolean) => ({
  maxWidth: 200,
  '& > div': {
    paddingRight: 0,
    color: applyWarningStyle ? theme.palette.error.main : 'unset',
  },
  '& input': {
    textAlign: 'right',
    padding: '6px 0 6px 6px',
    height: 'unset',
  },
  '& fieldset': {
    borderColor: applyWarningStyle ? theme.palette.error.main : '#B0BEC5',
  },
});

const styles = makeStyles((theme) => ({
  subtitle: {
    fontFamily: 'inherit',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '150%',
    color: '#192542',
  },
  valueAvailable: {
    ...valueAvailableDefaultRules(theme),
    '& strong': {
      color: ERebrandingColors.MAIN,
    },
  },
  valueAvailableLimit: {
    ...valueAvailableDefaultRules(theme),
    paddingTop: 16,
    borderTop: 'thin solid #ECEFF1',
    '& strong': {
      color: theme.palette.error.main,
    },
  },
  selectValueAvailable: {
    padding: '14px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 16,
    lineHeight: '150%',
    color: theme.palette.grey[500],
    borderTop: 'thin solid #ECEFF1',
  },
  inputValue: {
    ...inputValueDefaultRules(theme),
  },
  inputValueWarning: {
    ...inputValueDefaultRules(theme, true),
  },
  selectLabel: {
    display: 'block',
    fontSize: 14,
    color: theme.palette.grey[500],
    padding: '16px 0',
  },
  clearValue: {
    fontSize: 16,
    color: '#B0BEC5',
    cursor: 'pointer',
  },
  tooltipIcon: {
    width: 16,
    height: 16,
    marginLeft: 4,
  },
  alertList: {
    paddingBottom: 16,
  },
  alertItem: {
    boxShadow: 'none',
    fontSize: 12,
    padding: '.7rem',
  },
  alertText: {
    fontSize: 14,
    lineHeight: '1.5',
    '&:not(:last-of-type)': {
      marginBottom: 8,
    },
  },
  selectAccount: {
    borderTop: '#ECEFF1 thin solid',
  },
  successMsg: {
    textAlign: 'center',
    fontSize: 14,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > img': {
      marginBottom: 24,
    },
    '& > strong': {
      paddingTop: 16,
    },
  },
}));

export default styles;
